module.exports = __webpack_public_path__ + "static/images/list-banner3.c823012.png";